<script>
export default {
    name: "ApprovalModal",

    props: {

        consultant: Object,
        showModal: Boolean
    },

    methods: {

        approveUser() {

            this.$root.loading = true;
            this.$http.post(`MasterData/ApproveConsutants?ID=${this.consultant.id}&UserName=${this.$root.username}`)
                .then(response => {
                    this.$emit('refresh');
                    this.$root.loading = false;
                    this.$emit('closeModal');
                    window.Swal.fire({ type: 'success', title: response.data });
                }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-1/4">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Confirm Approve Consultant</h5>
      </template>
      <template v-slot:modal-body>
        <div class="-m-4">
          <h5 class="text-center font-bold text-base">Approve - {{ consultant.names }}</h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" @click.prevent="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" @click.prevent="approveUser"><i class="fa fa-check"></i> Approve</button>
      </template>
    </tail-modal>
</template>
